import { createFileRoute } from '@tanstack/react-router'
import { AccountPage } from '~/features/account/AccountPage'
import { accountQuery, sessionsListQuery } from '~/features/account/queries'

export const Route = createFileRoute('/_app/konto')({
  loader: ({ context }) =>
    Promise.all([context.queryClient.ensureQueryData(accountQuery), context.queryClient.ensureQueryData(sessionsListQuery)]),
  component: AccountPage,
})
